import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import Icon from "../../icons";
import { cn } from "../../utils";
import Badge from "../Badge";
import ButtonToggle from "../ButtonToggle/ButtonToggle";
const ButtonFilter = React.forwardRef((props, ref) => {
    const { countBadge, size = "md", icon, disabled, pressed, ...rest } = props;
    const showBadge = !!(countBadge && countBadge > 0);
    const classIsDisabled = cn(disabled && "cursor-not-allowed border border-primary-a7 bg-primary-4 text-primary-a9");
    const iconDefault = icon || _jsx(Icon, { name: "filter" });
    return (_jsx(Badge, { position: "top-right", variant: "contained", hide: !showBadge, size: "xs", content: countBadge, color: "primary", className: classIsDisabled, children: _jsx(ButtonToggle, { size: size, startIcon: iconDefault, pressed: pressed || showBadge, endIcon: _jsx(Icon, { name: "chevron-down" }), disabled: disabled, ...rest, ref: ref }) }));
});
ButtonFilter.displayName = "ButtonFilter";
export default ButtonFilter;
